"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const DocumentImpl_1 = require("./DocumentImpl");
/**
 * Represents an XML document.
 */
class XMLDocumentImpl extends DocumentImpl_1.DocumentImpl {
    /**
     * Initializes a new instance of `XMLDocument`.
     */
    constructor() {
        super();
    }
}
exports.XMLDocumentImpl = XMLDocumentImpl;
//# sourceMappingURL=XMLDocumentImpl.js.map